// src/firebase.js
import { initializeApp } from 'firebase/app';
import { 
    getAuth, 
    GoogleAuthProvider, 
    OAuthProvider,
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    signOut,
    onAuthStateChanged,
    updateProfile
} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyCY3r6Efvrr918YeRV-qSJAaygfBF_3yz4",
    authDomain: "phcourse-c8bc0.firebaseapp.com",
    projectId: "phcourse-c8bc0",
    storageBucket: "phcourse-c8bc0.firebasestorage.app",
    messagingSenderId: "396793948117",
    appId: "1:396793948117:web:64af02e6c72be603407f5c",
    measurementId: "G-196SGGTCTX"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Firestore
export const db = getFirestore(app);

// Google Auth Provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
    prompt: 'select_account' // Always show account selection
});

// Microsoft Auth Provider (if you want to use it later)
export const microsoftProvider = new OAuthProvider('microsoft.com');

// Auth helper functions
export const createUserAccount = (email, password) => {
    return createUserWithEmailAndPassword(auth, email, password);
};

export const signInUser = (email, password) => {
    return signInWithEmailAndPassword(auth, email, password);
};

export const signOutUser = () => {
    return signOut(auth);
};

export const updateUserProfile = (user, profileData) => {
    return updateProfile(user, profileData);
};

// Auth state observer
export const onAuthChange = (callback) => {
    return onAuthStateChanged(auth, callback);
};

export default app;